import React from 'react';

import { OilSettings } from 'screens/shared';

const GasEngineOil = (props) => {
  const engineValues = {
    reset: '100.0'
  };

  return <OilSettings engineValues={engineValues} {...props} />;
};

export default GasEngineOil;



// WEBPACK FOOTER //
// ./src/screens/Gas/GasSettings/GasEngineOil/GasEngineOil.js